import { render, staticRenderFns } from "./iodid-ionen.vue?vue&type=template&id=d8e4f196&"
import script from "./iodid-ionen.vue?vue&type=script&lang=js&"
export * from "./iodid-ionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports